import { render, staticRenderFns } from "./unknown.vue?vue&type=template&id=daa28c14&scoped=true"
import script from "./unknown.vue?vue&type=script&lang=js"
export * from "./unknown.vue?vue&type=script&lang=js"
import style0 from "./unknown.vue?vue&type=style&index=0&id=daa28c14&prod&lang=scss&scoped=true"
import style1 from "./unknown.vue?vue&type=style&index=1&id=daa28c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa28c14",
  null
  
)

export default component.exports